/**
 * created by wang lei
 完全拆分单元格 页面
 *
 */
import React, {Component} from 'react';
import splitCells from './splitCells.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class SplitCellsTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            splitCells:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let splitCells = this.props.editor.queryCommandState("splittocells")
        this.setState({splitCells: splitCells === 0});
    }

    /**
     * 监听编辑器点
     */
    listenContentClick(){
        let splitCells = this.props.editor.queryCommandState("splittocells")
        this.setState({splitCells: splitCells === 0});
    }

    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.splitCells ? "1":"0.3"}}>
                <img className={"editor-splittoCells-tool-btn"} src={splitCells}
                     onClick={()=>this.props.editor.execCommand("splittocells")}/>
                {this.state.splitCells ? <style>{`
                .editor-splittoCells-tool-btn{
                    border: 1px solid #f2f6fc
                }   
                .editor-splittoCells-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-splittoCells-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-splittoCells-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-splittoCells-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-splittoCells-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}